import { render, staticRenderFns } from "./PriceIndexSelect.vue?vue&type=template&id=16b587e4"
import script from "./PriceIndexSelect.vue?vue&type=script&lang=js"
export * from "./PriceIndexSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports